import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { FiMapPin, FiMail, FiPhone, FiUser } from 'react-icons/fi';

export default function About() {
  return (
    <div className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center mb-16"
        >
          <h1 className="text-4xl font-extrabold text-gray-900 mb-4">About Us</h1>
          <div className="w-24 h-1 bg-blue-600 mx-auto rounded"></div>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.2 }}
          >
            <h2 className="text-3xl font-bold text-gray-900 mb-6">Who We Are</h2>
            <p className="text-lg text-gray-600 leading-relaxed mb-6">
              World Class Ventures LLC is a company that helps homeowners and business owners educate themselves on mortgages, bookkeeping and getting started in the real estate industry.
            </p>
            <p className="text-lg text-gray-600 leading-relaxed">
              Based at 4641 Hermitage Rd, Mobile AL 36619, we pride ourselves on providing exceptional service, every time. Our goal is to empower our clients with the knowledge and tools they need to succeed in their real estate endeavors.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.4 }}
            className="bg-gray-50 p-8 rounded-2xl border border-gray-100 shadow-sm"
          >
            <h3 className="text-2xl font-bold text-gray-900 mb-8">Contact Information</h3>
            
            <div className="space-y-6">
              <div className="flex items-start">
                <div className="flex-shrink-0 mt-1">
                  <div className="w-10 h-10 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center">
                    <SafeIcon icon={FiUser} className="text-xl" />
                  </div>
                </div>
                <div className="ml-4">
                  <h4 className="text-lg font-semibold text-gray-900">Representative</h4>
                  <p className="mt-1 text-gray-600">Andy Khong</p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="flex-shrink-0 mt-1">
                  <div className="w-10 h-10 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center">
                    <SafeIcon icon={FiMapPin} className="text-xl" />
                  </div>
                </div>
                <div className="ml-4">
                  <h4 className="text-lg font-semibold text-gray-900">Our Location</h4>
                  <p className="mt-1 text-gray-600">
                    4641 Hermitage Rd<br />
                    Mobile AL 36619
                  </p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="flex-shrink-0 mt-1">
                  <div className="w-10 h-10 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center">
                    <SafeIcon icon={FiMail} className="text-xl" />
                  </div>
                </div>
                <div className="ml-4">
                  <h4 className="text-lg font-semibold text-gray-900">Email Us</h4>
                  <a href="mailto:andrewkhong30@gmail.com" className="mt-1 text-blue-600 hover:underline block">
                    andrewkhong30@gmail.com
                  </a>
                </div>
              </div>

              <div className="flex items-start">
                <div className="flex-shrink-0 mt-1">
                  <div className="w-10 h-10 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center">
                    <SafeIcon icon={FiPhone} className="text-xl" />
                  </div>
                </div>
                <div className="ml-4">
                  <h4 className="text-lg font-semibold text-gray-900">Call Us</h4>
                  <a href="tel:+12512352120" className="mt-1 text-blue-600 hover:underline block">
                    +1 (251) 235-2120
                  </a>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  );
}